import React from 'react';
import Image, { ImageProps } from 'next/image';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { Box } from '@firsttable/web-components/atoms';
import { SpaceProps, space } from 'styled-system';
import IconArrowDownNav from '@firsttable/web-components/atoms/Icon/IconArrowDownNav';
import MainMenu from '../../organisms/Navigation';

export const Background = styled.section<SpaceProps>`
  position: relative;
  ${space};
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5));
  mix-blend-mode: normal;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: relative;
  opacity: 1 !important;
  min-height: 540px;
`;
export const BackgroundImage = styled(Image)<ImageProps>`
  position: relative;
  z-index: -1;
`;

const StyledImageBackground = ({ children, ...props }: { children: any } & SpaceProps) => (
  <Background {...props}>
    <BackgroundImage
      alt="First Table"
      src="/images/bg-header-01.jpg"
      priority
      sizes="100vw"
      fill
      style={{ objectFit: 'cover' }}
    />
    {children}
  </Background>
);
StyledImageBackground.propTypes = {
  children: PropTypes.node,
};

const HeaderWave = styled(Box)`
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 140px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-end;

  @media (min-width: 1600px) {
    height: 100%;
  }
`;

const chevronAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
`;

const Chevron = styled(Box)`
  position: absolute;
  bottom: 150px;
  left: 50%;
  width: 28px;
  height: 28px;
  margin-left: -14px;
  animation: 2s ${chevronAnimation} ease-in-out infinite;
  ${({ onClick }) =>
    typeof onClick === 'function'
      ? css`
          cursor: pointer;
        `
      : null};
`;

type HeroBackgroundImageType = {
  children: any;
  arrowHelper?: boolean;
  scrollTo?: () => void;
  showMenu?: boolean;
} & SpaceProps;
const HeroBackgroundImage = ({
  children,
  arrowHelper,
  scrollTo,
  showMenu = true,
  ...props
}: HeroBackgroundImageType) => (
  <StyledImageBackground mb={['xxl', 96]} pb={[72, 140]} {...props}>
    {showMenu && <MainMenu transparent mb={['xxl', 70]} />}
    <Box position="relative" display="flex" alignItems="center" minHeight={[null, 470]}>
      <Box flex={1}>{children}</Box>
    </Box>
    <HeaderWave>
      <svg
        width="100%"
        viewBox="0 0 1600 86"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M800 54.0001C186 145 0 14.0001 0 14.0001V154H1600V14.0001C1600 14.0001 1555.81 1.88336 1439.4 0H1376.03C1251.01 1.84955 1065.53 14.6465 800 54.0001Z"
          fill="#fff"
        />
      </svg>
    </HeaderWave>
    {arrowHelper && (
      <Chevron display={['none', 'block']} onClick={scrollTo}>
        <IconArrowDownNav color="white" />
      </Chevron>
    )}
  </StyledImageBackground>
);

HeroBackgroundImage.propTypes = {
  children: PropTypes.node,
  arrowHelper: PropTypes.bool,
  scrollTo: PropTypes.func,
  showMenu: PropTypes.bool,
};

export default HeroBackgroundImage;
